import React from 'react';
import {TextArea as NBTextArea, IInputProps} from 'native-base';

export const TextArea = (props: IInputProps) => {
  return(
    <NBTextArea {...props}></NBTextArea>
  )
};